import { assign } from 'lodash'

export function User(user) {
  return assign(user, {
    fullName: fullName(user)
  })
}

export function fullName({ firstName, lastName }) {
  return `${firstName} ${lastName}`
}
